module.exports = __webpack_public_path__ + "static/media/LAND.646f8448.svg";